import { render } from "./PunchPage.vue?vue&type=template&id=870f804e&scoped=true"
import script from "./PunchPage.vue?vue&type=script&lang=js"
export * from "./PunchPage.vue?vue&type=script&lang=js"

import "./PunchPage.vue?vue&type=style&index=0&id=870f804e&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-870f804e"]])

export default __exports__